<p
  *ngIf="status"
  class="bl-margin--0 bl-font-size--22 bl-font-weight--800 bl-display--flex bl-justify-content--flex-start bl-align-items--flex-start
  {{ statusColorClass(status) }} {{ statusClass }} "
>
  {{ getStatus() }}
</p>
